<template>
  <section id="login" class="login">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-4">
          <b-overlay :show="loading" rounded="sm" bg-color="#f8f9fa">
            <div class="card">
              <div class="card-body">
                <div class="card-text text-center">
                  <b-form @submit.stop.prevent="onSubmit" class="login-form">
                    <b-form-group
                      id="api-key-group"
                      label-for="api-key"
                    >
                      <template v-slot:label>
                        Key
                      </template>
                      <b-form-input
                        id="api-key"
                        v-model.trim="form.api_key"
                        type="text"
                        aria-describedby="input-api-key-feedback"
                        :placeholder="'Enter key'"
                        class="text-center"
                        :class="{ 'is-invalid': $v.form.api_key.$error }"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="input-api-key-feedback">
                        Key should not empty
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      id="api-secret-group"
                      label-for="api-secret-input-group"
                    >
                      <template v-slot:label>
                        Secret
                      </template>
                      <b-input-group
                          id="api-secret-input-group"
                          class="input-group-merge">
                        <b-form-input
                          id="api-secret"
                          v-model.trim="form.api_secret"
                          :type="typeSecretCode"
                          aria-describedby="input-api-secret-feedback"
                          :placeholder="'Enter secret'"
                          class="text-center"
                          :class="{ 'is-invalid': $v.form.api_secret.$error }"
                        ></b-form-input>
                        <b-input-group-append
                          :class="{ 'is-invalid': $v.form.api_secret.$error }">
                          <b-button class="show-hide-secret" @click="showHideSecretCode">
                            <i class="fa fa-eye" v-if="!showSecretCode"></i>
                            <i class="fa fa-eye-slash" v-else></i>
                          </b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback
                          id="input-api-secret-feedback">
                          Secret should not empty
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group class="text-right mt-4">
                      <b-button
                        id="login-btn"
                        type="submit"
                        class="btn btn-lg btn-block login-btn">
                        LOGIN
                      </b-button>
                    </b-form-group>
                  </b-form>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      typeSecretCode: 'password',
      showSecretCode: false,
      form: {
        api_key: '',
        api_secret: '',
      },
    };
  },
  validations: {
    form: {
      api_key: { required },
      api_secret: { required },
    },
  },
  methods: {
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$nextTick(() => {
        this.loading = true;
      });

      this.$store.dispatch('login', this.form)
        .then((response) => {
          if (response.code === 200 || response.status_code === 200) {
            this.$session.start();
            this.$session.set('jwt', response.data.token);
            if (response.data.is_multicolli) {
              this.$router.push({ name: 'multicolli' });
            } else {
              this.$router.push({ name: 'index' });
            }
          } else {
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: response.message || 'Something wrong',
            });
            this.loading = false;
          }
        })
        .catch((error) => {
          let message = 'Something wrong';
          if (typeof error.response !== 'undefined') {
            message = `${error.response.data.message}`;
          }
          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: message,
          });
          this.loading = false;
        });

      if (this.loading) {
        setTimeout(() => {
          this.loading = false;
        },
        3000);
      }
    },
    showHideSecretCode() {
      this.showSecretCode = !this.showSecretCode;
      if (this.showSecretCode) {
        this.$nextTick(() => {
          this.typeSecretCode = 'text';
        });
      } else {
        this.$nextTick(() => {
          this.typeSecretCode = 'password';
        });
      }
    },
  },
};
</script>
<style>
.login .spinner-border {
  color: #5e50a1;
}
.login .login-form label {
  font-family: "GothamMedium";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #424143;
}
.login .login-form input,
.login .login-form input::placeholder,
.login .login-form .input-group-append .show-hide-secret {
  font-family: "GothamBook";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #868686;
}
.login .login-form .input-group-append .show-hide-secret {
  background-color: transparent;
  border-color: #ced4da;
  width: 43.5px;
}
</style>
<style scoped>
.login,
.login .container,
.login .container .row {
  height: 100%;
}
.login::-webkit-scrollbar {
  width: 0px;
}
.login .card {
  padding: 10px 40px
}
.login .login-form .login-btn {
  font-family: "GothamMedium";
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  background-color: #5e50a1;
  border: none;
}
.login .login-form input:focus,
.login .login-form .login-btn:focus,
.login .login-form .input-group-append .show-hide-secret {
  outline: none;
  box-shadow: none;
}
.login .login-form .input-group-append .show-hide-secret {
  border-left: none;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.login .login-form .input-group-append.is-invalid .show-hide-secret,
.login .login-form .input-group-append.is-invalid i {
  border-color: #dc3545;
  color: #dc3545;
  border-left: none;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
</style>
